import { Global } from '@emotion/react';
import { colors } from '@rtkwlf/fenrir-react';

export const GlobalStyles = () => (
  <Global
    styles={{
      // * transition between fenrir legacy and fenrir *
      // - needs to be outside of global layer to properly override fenrir
      body: {
        // update to fenrir defaults while transitioning to up-ia
        backgroundColor: 'var(--aw-palette-background-base)',
        color: 'var(--aw-palette-text-primary)',
        // - include line-height: normal to override Mui global styles
        lineHeight: 'normal',
      },
      // make global styles less specific to allow easy override
      '@layer global': {
        a: {
          color: `rgb(${colors.text.brand.default})`,
        },
        ul: {
          listStyleType: 'none',
          margin: 0,
          padding: 0,
        },
      },
    }}
  />
);
